import { MouseEventHandler } from 'react';
import { PrimaryButton } from '@/common/Button';

type OwnProps = {
  ctaProps: {
    dataAnalyticsId: string;
    dataAnalyticsAttributes?: string;
    dataNativePayload?: string;
    dataQa?: string;
    href: string;
    onClick?: MouseEventHandler<HTMLAnchorElement>;
  };
};

export default function DefaultTradeCard({ ctaProps }: OwnProps) {
  const backgroundImage = `${process.env.CVNA_APP_CDN_ASSETS_PATH}/images/stc-background-7-24.png`;

  return (
    <div
      className="flex flex-col justify-between rounded-[6px] border border-grey-2 bg-cover bg-center p-2xl text-white"
      data-qa="apply-trade-in-card"
      style={{
        backgroundImage: `url(${backgroundImage})`
      }}
    >
      <div className="flex flex-auto flex-col gap-xl pb-xl">
        <h3 className="tl-header-m" data-qa="trade-card-heading">
          Sell/Trade Your Car
        </h3>
        <p className="tl-body-m" data-qa="no-trade-paragraph">
          Get a real offer in less than 2 minutes — sell, trade or track your
          value.
        </p>
      </div>
      <a
        className="w-full"
        data-analytics-id={ctaProps.dataAnalyticsId}
        data-analytics-attributes={ctaProps.dataAnalyticsAttributes}
        data-native-payload={ctaProps.dataNativePayload}
        data-qa={ctaProps.dataQa}
        href={ctaProps.href}
        onClick={ctaProps.onClick}
      >
        <PrimaryButton className="h-40 min-h-40 w-full !px-12" mode="dark">
          get your offer
        </PrimaryButton>
      </a>
    </div>
  );
}
